"use strict";

import React, {Fragment} from 'react';
import dateFormat from "dateformat";
import {dateDiffDays, myTimestampToDate} from "../../time";
import SvgLeavePageIcon from "../../component/SvgLeavePageIcon";

const OrderShipment = ({shipment}) => {
    const shipDate = dateFormat(myTimestampToDate(shipment.ship_date), 'mm/dd/yyyy');
    const daysSinceShipped = +dateDiffDays(shipDate);

    return (
        <li className="display__table__row">
            <div className="display__table__cell">
                    {shipment.service}
            </div>
            <div className="display__table__cell">
                { !!(daysSinceShipped < 60) &&
                    <a href={shipment.tracking_url} title="view tracking information" target="_blank">
                        {shipment.tracking_number} <SvgLeavePageIcon color="#6C4212" size="16"/>
                    </a>
                    ||
                    <Fragment>{shipment.tracking_number}</Fragment>
                }
            </div>
            <div className="display__table__cell">
                    {shipDate}
            </div>
        </li>
    );
};

export default OrderShipment;
